import { Guide } from '../components/Guide'
import { guides } from '../content/guides'

export const ObjectsAndBlocksPage = () => <Guide content={guides.objects} />
